/** @format */

import {type MetricInput} from 'features/mediaplan-progress/types';

// A forecast needs at least a week of fact to be meaningful (AS-7886): with fewer than 7 days
// of fact we neither compute nor show the forecast — no dashed chart tail and no «Прогноз» row.
export const MIN_FORECAST_DAYS = 7;

/** Number of days that already have fact in the current period. */
const countFactDays = (input: MetricInput): number =>
  input.kind === 'additive' ? Object.keys(input.factDaily).length : input.ratio.factDays.length;

// Show the forecast only with ≥7 days of fact AND an actual forecast tail. Without forecast days
// (no mediaplan, or fact already covering the whole period) forecastAtEnd is structurally 0, so a
// «Прогноз 0 ₽» would be misleading.
export const shouldShowForecast = (input: MetricInput): boolean =>
  countFactDays(input) >= MIN_FORECAST_DAYS && input.forecastDays.length > 0;
